import {each} from 'underscore';
import {Model, View} from 'backbone';
import {emitChanges, postJSON} from 'common';
import {task} from 'loader';
import rivets from 'rivets';

export default View.extend({

    events: {
        'click button[data-action=send]': 'send',
        'click button[data-action=login]': 'login'
    },

    initialize() {
        this.state = new Model({
            account: 'guest'
        });

        this.state.on('change:account', this.changeAccount, this);

        this.errors = new Model({});

        this.sectionAccount = this.el.querySelector('[data-section=account]');
        this.sectionLogin = this.el.querySelector('[data-section=login]');
        this.sectionSignup = this.el.querySelector('[data-section=signup]');
        this.sectionMessage = this.el.querySelector('[data-section=message-text]');
        this.sectionNotes = this.el.querySelector('[data-section=notes]');
        this.sectionPersonal = this.el.querySelector('[data-section=personal]');
        this.sectionStay = this.el.querySelector('[data-section=stay]');
        this.sectionSubmit = this.el.querySelector('[data-section=submit]');

        this.blockEmail = this.sectionPersonal?.querySelector('[data-block=email]');
        this.blockEmail4 = this.sectionMessage?.querySelector('[data-block=email4]');
        this.rowPersonal = this.sectionMessage?.querySelector('[data-row=personal]');

        rivets.bind(this.el, {
            b: this.state,
            e: this.errors
        });

        emitChanges(this.el);
    },

    /**
     * @param {Model} _m
     * @param {String} value
     */
    changeAccount(_m, value) {
        const login = value === 'login';
        const signup = value === 'signup';
        const guest = value === 'guest';

        this.sectionLogin.hidden = !login;
        this.sectionSignup.hidden = !signup;
        this.sectionSubmit.hidden = !(signup || guest);
        if (this.sectionNotes) {
            this.sectionNotes.hidden = !(signup || guest);
        }
        if (this.sectionStay) {
            this.sectionStay.hidden = !(signup || guest);
        }
        if (this.sectionMessage) {
            this.sectionMessage.hidden = !(signup || guest);
            this.blockEmail4.hidden = !guest;
            this.rowPersonal.hidden = !(signup || guest);
        }
        if (this.sectionPersonal) {
            this.sectionPersonal.hidden = !(signup || guest);
            this.blockEmail.hidden = !guest;
        }
    },

    /**
     * @param {MouseEvent & {currentTarget: HTMLButtonElement}} ev
     */
    async send({currentTarget: btn}) {
        this.errors.clear();

        const data = this.state.toJSON();
        const sale = Number(this.el.dataset.sale);

        try {
            btn.disabled = true;
            const res = await task(() => postJSON(`/sales/${sale}/contact`, data));
            location.href = res.url ?? '/book-message-thanks';

        } catch (error) {
            if (error.code === 400) {
                const errors = {};
                each(error.details, (value, field) => {
                    errors[field] = value.join('\n');
                });

                this.errors.set(errors);
            }

        } finally {
            btn.disabled = false;
        }
    },

    /**
     * @param {MouseEvent & {currentTarget: HTMLButtonElement}} ev
     */
    async login({currentTarget: btn}) {
        this.errors.clear();

        try {
            btn.disabled = true;
            await GA.login(this.state.get('email'), this.state.get('password'));
            this.state.unset('password');

        } catch (error) {
            this.errors.set({email: error.reason});

        } finally {
            btn.disabled = false;
        }
    },

    async user(user) {
        this.state.set('account', 'guest');
        this.sectionAccount.hidden = user.role === 'user';
        if (user.role === 'user') {
            const profile = await GA.profile();
            this.state.set(profile);
        }
    }
});
